import { attr, BaseModel } from "../../lib/itn-ui-kit/data";

export default class UserRoleModel extends BaseModel {
  static urlPath = "user_roles";

  @attr("number") pk;
  @attr("date") createdAt;
  @attr("date") updatedAt;
  @attr("string") name;
  @attr("string") description;
  @attr("array") role_permissions;
  @attr("string") for_type;
}
